import React, { useRef, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import ReactToPrint from "react-to-print";
import ExpandedSencoReportView from "./ExpandedSencoReportView";
import "./PrintClassResults.css";
import ExpandedSENWatchlistView from "./ExpandedSENWatchlistView";

const YEAR_RANGES = {
  "24/25": { start: "2024-08-15", end: "2025-08-15" },
  "23/24": { start: "2023-08-15", end: "2024-08-15" },
  "22/23": { start: "2022-08-15", end: "2023-08-15" },
};

function getCurrentAcademicYear(date = new Date()) {
  const currentTimestamp = date.getTime();
  for (const [label, range] of Object.entries(YEAR_RANGES)) {
    const start = new Date(range.start).getTime();
    const end = new Date(range.end).getTime();
    if (currentTimestamp >= start && currentTimestamp < end) {
      return label;
    }
  }
  return "Unknown Year";
}

function PrintSENWatchlist(props) {
  const {
    classDetails,
    classAssessments,
    // gradeLevel,
    teachers,
    assessment,
    students,
    studentsReadingScore,
    showAtRiskOnly,
    onSortData,
    showSortedData,
    schoolid,
  } = props;

  const componentRef = useRef();

  console.log(props.schoolid);

  return (
    <>
      <style>
        {`
          @media print {
            @page {
              size: landscape;
            }
          }
        `}
      </style>
      <SencoReportPrintable
        ref={componentRef}
        classDetails={classDetails}
        // gradeLevel={gradeLevel}
        teachers={teachers}
        assessment={assessment}
        students={students}
        studentsReadingScore={studentsReadingScore}
        showAtRiskOnly={showAtRiskOnly}
        onSortData={onSortData}
        showSortedData={showSortedData}
        schoolid={props.schoolid}
      />
      <ReactToPrint
        content={() => componentRef.current}
        trigger={() => <button className="print-button">Print</button>}
      />
    </>
  );
}

const SencoReportPrintable = React.forwardRef((props, ref) => {
  const academicYear = getCurrentAcademicYear();
  return (
    <div
      className="senco-hide-div senco-landscape-print"
      ref={ref}
      style={{ position: "relative", minHeight: "100vh" }}
    >
      {/* Print-only header */}
      <div className="alpaca-print-header">
        <div className="printout-logo" />
        <div className="alpaca-print-header-text">
          <span className="alpaca-print-header-class">
            {props.classDetails?.name || "Class Name"}
          </span>
          <span className="alpaca-print-header-year">
            School Year: {academicYear}
          </span>
        </div>
      </div>
      <Row className="mt-5 text-center">
        <Col className="printout-logo col-2"></Col>
        <Col className="col-4">
          <h3 className="printout-page-description-header">
            {"SEN Watchlist"}
          </h3>
        </Col>
        <Col className="col-4">
          <h3 className="printout-page-description-header">{""}</h3>
        </Col>
        <Col className="col-2">
          <h3 className="printout-page-description-header">
            {new Date().toLocaleString("default", { month: "long" })}{" "}
            {new Date().getFullYear()}
          </h3>
        </Col>
      </Row>
      <Row>
        <ExpandedSENWatchlistView
          students={props.students}
          classDetails={props.classDetails}
          //   classid={props.classDetails.id}
          //   gradeLevel={props.gradeLevel}
          teachers={props.teachers}
          assessment={props.assessment}
          studentsReadingScore={props.studentsReadingScore}
          showSortedData={props.showSortedData}
          showAtRiskOnly={props.showAtRiskOnly}
          onSortData={props.onSortData}
          schoolid={props.schoolid}
        />
      </Row>
      {/* <div
        style={{
          position: "fixed",
          left: 0,
          bottom: 0,
          width: "100%",
          textAlign: "center",
          fontSize: "0.9rem",
          color: "#888",
          padding: "8px 0",
          background: "white",
          zIndex: 1000,
        }}
      >
        Powered by ALPACA &copy; {new Date().getFullYear()}
      </div> */}
    </div>
  );
});

export default PrintSENWatchlist;
